import React, { Component } from 'react';
import {
  Menu,
  Header,
  Segment,
  Responsive,
  Icon,
  Sidebar
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import NavBarLoggedIn from './NavBarLoggedIn';
import NavBarLoggedOut from './NavBarLoggedOut';
import NavBarMobileLoggedOut from './NavBarMobileLoggedOut';
import NavBarMobileLoggedIn from './NavBarMobileLoggedIn';
import { HOME_ROUTE } from '../../constants/route.constants';
import { APP_NAME } from '../../constants/resource.constants';
import { app } from '../../modules';

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      isSidebarVisible: false
    };
  }

  componentDidMount() {
    this.setState({ user: this.props.user });

    if (!this.props.user || !this.props.user.email) {
      app
        .authenticate()
        .then(response => {
          this.props.receiveAuth(response.user);
        })
        .catch(err => {
          // // TODO: Log error
          return;
        });
    }

    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.handleRouteChange = this.handleRouteChange.bind(this);
  }

  componentWillUpdate(newProps) {
    if (this.props.user !== newProps.user) {
      this.setState({ user: newProps.user });
    }
  }

  toggleSidebar() {
    this.setState({ isSidebarVisible: !this.state.isSidebarVisible });
  }

  handleRouteChange(path) {
    this.setState({ isSidebarVisible: false });
    this.props.history.push(path);
  }

  render() {
    return (
      <div>
        <Menu>
          <Header as="h1" textAlign="left" className="header-title">
            <Link to={HOME_ROUTE}>
              <img
                src="https://d3hfkx84ni8spj.cloudfront.net/misc/logo.jpg"
                alt={APP_NAME}
              />
            </Link>
          </Header>
          <Responsive
            as={Menu.Item}
            minWidth={767}
            className="header__menu-right"
          >
            {this.state.user && this.state.user.email ? (
              <NavBarLoggedIn
                history={this.props.history}
                requestLogout={this.props.requestLogout}
                user={this.state.user}
                clubSearch={this.props}
              />
            ) : (
              <NavBarLoggedOut
                history={this.props.history}
                clubSearch={this.props}
              />
            )}
          </Responsive>
          <Responsive as={Menu.Menu} maxWidth={767} position="right">
            <Menu.Item name="mobilemenu" onClick={this.toggleSidebar}>
              <Icon name="bars" size="big" className="menu-icon" />
            </Menu.Item>
          </Responsive>
        </Menu>
        <Sidebar.Pushable
          as={Segment}
          className={this.state.isSidebarVisible ? 'visible' : ' '}
        >
          {this.state.user && this.state.user.email ? (
            <NavBarMobileLoggedIn
              handleRouteChange={this.handleRouteChange}
              isSidebarVisible={this.state.isSidebarVisible}
              requestLogout={this.props.requestLogout}
              history={this.props.history}
              clubSearch={this.props}
              user={this.state.user}
            />
          ) : (
            <NavBarMobileLoggedOut
              handleRouteChange={this.handleRouteChange}
              isSidebarVisible={this.state.isSidebarVisible}
              history={this.props.history}
              clubSearch={this.props}
            />
          )}
        </Sidebar.Pushable>
      </div>
    );
  }
}

NavBar.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string,
    email: PropTypes.string
  }),
  requestLogout: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarView.js